module.exports = __webpack_public_path__ + "img/006.f69b606c.png";